<script lang="ts">
    import type {AuthorityDetailReactivePageData, AuthorityDetailStaticPageData} from '../types';
    import {SearchType} from 'shared/constants/portaro.constants';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpSearchContext from '../../../search/kp-search-context/KpSearchContext.svelte';
    import KpSearch from '../../../search/kp-search/KpSearch.svelte';

    const pageContext = getPageContext<AuthorityDetailStaticPageData, AuthorityDetailReactivePageData>();
    const searchContextParams = {type: SearchType.TYPE_BY_AUTHORITY, recordRelatedRecord: pageContext.staticData.model.record.id};
</script>

<KpSearchContext staticParams="{searchContextParams}" let:searchManager>
    <KpSearch {searchManager}/>
</KpSearchContext>